import React from 'react';
import LastValueMappingRow from './LastValueMappingRow';
import RegularValueMappingRow from './RegularValueMappingRow';
import SingleValueMappingRow from './SingleValueMappingRow';

const AddRemoveAdornment = ({
	single,
	first,
	last,
	onClickAdd,
	onClickRemove,
}: {
	single: boolean;
	first: boolean;
	last: boolean;
	onClickAdd: () => void;
	onClickRemove: () => void;
}) => {
	if (first && !single) return <div />;
	if (first && single) {
		return <SingleValueMappingRow onClickAdd={onClickAdd} />;
	}
	if (!last) return <RegularValueMappingRow onClickRemove={onClickRemove} />;
	return (
		<LastValueMappingRow
			onClickRemove={onClickRemove}
			onClickAdd={onClickAdd}
		/>
	);
};

export default AddRemoveAdornment;
